import React from 'react'
import { observer } from 'mobx-react-lite'

import { PrintFileCell } from './PrintFileCell'

import { useApi } from '../hooks/storeHook'

import { MyRowProps } from '../types/tableTypes'
import { PrintFileGroupModel } from '../server/mpsklad_core/Models/PrintFileGroupModel'

export const OzonFileCell =
  observer(
    ({row}: MyRowProps<PrintFileGroupModel>) => {
      const api = useApi()

      return <PrintFileCell
        row={row}
        makeLabelsUrl={api.label.ozonLabelsFileUrl}
        makePurchaseListUrl={api.label.ozonPurchaseListFileUrl}
        makeMsBarcodesUrl={api.label.ozonMsBarcodesFileUrl}/>
    })